import { render, staticRenderFns } from "./UpcomingEventDetails.vue?vue&type=template&id=5c6d6a90&scoped=true&"
import script from "./UpcomingEventDetails.vue?vue&type=script&lang=js&"
export * from "./UpcomingEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEventDetails.vue?vue&type=style&index=0&id=5c6d6a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d6a90",
  null
  
)

export default component.exports